export const convertToViewPageUrl = (url?: string): string =>
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	url!
		.split('/')
		.filter((part) => part !== 'edit-v2')
		.join('/');
